import { mount } from "@vue/test-utils";
import YouTubeImage from "@/components/core/YouTubeImage";

describe("YouTubeImage test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(YouTubeImage);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component YouTubeImage", () => {
    expect(wrapper).toBeDefined();
  });
});
